import { brand } from './brand';

const disabledStorefrontPaths = new Set(brand.disabledStorefrontPaths);
const disabledAdminModules = new Set(brand.disabledAdminModules);

export function isBrandCommerceEnabled(): boolean {
  return brand.capabilities.commerce;
}

export function isBrandManualProductSkuEnabled(): boolean {
  return brand.capabilities.manualProductSku;
}

export function isBrandStorefrontPathEnabled(pathSegment: string): boolean {
  return !disabledStorefrontPaths.has(pathSegment);
}

export function isBrandAdminModuleEnabled(moduleKey: string): boolean {
  return !disabledAdminModules.has(moduleKey);
}
